// extracted by mini-css-extract-plugin
export default {"container":"ini_3_c5z","circle":"ini_cir_2eY4G","initials":"ini_ini_cwF45","withoutCircle":"ini_wit_3Xw7g","picture":"ini_pic_3J94D"};